module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('div', {
    staticClass: "community"
  }, [_c('div', {
    staticClass: "community__title mb-5"
  }, [_vm._v("Communities")]), _vm._v(" "), _c('div', {
    staticClass: "community__subtitle my-3"
  }, [_vm._v("Your profile")]), _vm._v(" "), _c('div', {
    staticClass: "community__item",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": require("../../assets/mobile/community.png")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "community__subtitle mb-3 mt-4"
  }, [_vm._v("Subscribed")]), _vm._v(" "), _c('div', {
    staticClass: "community__item mb-2",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": require("../../assets/mobile/community.png")
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "community__item",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": require("../../assets/mobile/community.png")
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "community__subtitle mt-4 mb-3"
  }, [_vm._v("Following")]), _vm._v(" "), _c('div', {
    staticClass: "community__item mb-5 pb-5",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": require("../../assets/mobile/community.png")
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("You")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Platinum • 1m")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("SALVA")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Platinum • 1m")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("Tri Nohbi")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Acapella packs • 1w")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("You")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Platinum • 1m")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40764274","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/community.vue
// module id = 1694
// module chunks = 180